import { isAnyOf } from '@reduxjs/toolkit';
import { startAppListening } from '../../listener';
import { resourceActions } from '../resources/slice';
import { themeActions } from '../themes/slice';
import { syncActions } from './slice';
import { SyncableAction } from './types';
import { useEffect } from 'react';
import { doSync } from './functions';
import { saveResource } from '../resources/actions';
import { accountStateSelector } from '../account/api';

export const startSyncListener = () => {

  let syncDebounceTimeout: NodeJS.Timeout | number | null = null;

  const listeners = [
    startAppListening({
      matcher: isAnyOf(
        resourceActions.deleteResource,
        saveResource,
        themeActions.deleteTheme,
        themeActions.saveTheme
      ),
      effect: (action, api) => {
        const state = api.getState();
        const accountState = accountStateSelector(state);
        const accountID = accountState.data?.id;

        if (accountID && accountState.isSuccess) {
          api.dispatch(syncActions.queue({
            accountID,
            action: action as SyncableAction
          }));
        }

      }
    }),
    startAppListening({
      matcher: isAnyOf(
        syncActions.queue,
        syncActions.forceSync
      ),
      effect: (_, api) => {
        if (syncDebounceTimeout) {
          clearTimeout(syncDebounceTimeout);
          syncDebounceTimeout = null;
        }

        syncDebounceTimeout = setTimeout(
          async () => {
            const state = api.getState();
            const accountState = accountStateSelector(state);
            await doSync(accountState.data, state.sync, api.dispatch);
          },
          1000
        );
      }
    })
  ];

  return () => {
    if (syncDebounceTimeout) {
      clearTimeout(syncDebounceTimeout);
      syncDebounceTimeout = null;
    }
    for (const cancel of listeners) {
      cancel();
    }
  };

};

export const useSyncListener = () => useEffect(startSyncListener, []);
